<app-search-input
  class="grid-quick-search__input"
  [placeholder]="placeholder() | translate"
  [value]="query()"
  (search)="submit($event)"
></app-search-input>
